import { createSelector } from 'reselect';

import IconsRenderer from '@pages/_components/iconsRenderer';
import SimpleLinkRenderer from '@pages/_components/simpleLinkRenderer';

export const reportModifierSelector = state =>
  state.getIn(['app', 'bi', 'search', 'reportModifier', 'data']).toJS();

export const appraisalCompaniesDataSelector = state =>
  state.getIn(['app', 'bi', 'search', 'appraisalCompanies', 'data']).toJS();

export const rollCorrectionsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'rollCorrections', 'data']).toJS();

export const activeReportJobSelector = state =>
  state.getIn(['app', 'bi', 'search', 'activeReportJob']).toJS();

export const stateCodesSelector = state =>
  state.getIn(['app', 'bi', 'search', 'stateCds', 'data']).toJS();

export const marketAreasSelector = state =>
  state.getIn(['app', 'bi', 'search', 'marketAreas', 'data']).toJS();

export const reportSubmissionsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'reportSubmissions']).toJS();

export const activeReportSubmissionSelector = state =>
  state.getIn(['app', 'bi', 'search', 'activeReportSubmission']).toJS();

export const reportMassCreateSelector = state =>
  state.getIn(['app', 'bi', 'search', 'massCreate']).toJS();

export const reportEventsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'reportEvents']).toJS();

export const activeReportSelector = state =>
  state.getIn(['app', 'bi', 'search', 'activeReport']).toJS();

export const addressFetchDataSelector = state =>
  state.getIn(['app', 'bi', 'search', 'addressFetchData']).toJS();

export const editDataSelector = state =>
  state.getIn(['app', 'bi', 'search', 'editSketch', 'data']).toJS();

export const taxingUnitsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'taxingUnits']).toJS();

export const appraisalSearchSelector = state =>
  state.getIn(['app', 'appraisal', 'property', 'results']).toJS();

export const gisSettingsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'gisSettings']).toJS();

export const ciSettingsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'ciSettings']).toJS();

export const initialSketchDataSelector = state =>
  state.getIn(['app', 'bi', 'search', 'sketchData']).toJS();

export const reportInfoSelector = state =>
  state.getIn(['app', 'bi', 'search', 'reportInfo']).toJS();

export const searchConfigSelector = state =>
  state.getIn(['app', 'bi', 'search', 'config', 'data']).toJS();

export const searchCodesSelector = state =>
  state.getIn(['app', 'bi', 'search', 'codes', 'data']).toJS();

export const searchResultsConfigSelector = state =>
  state.getIn(['app', 'bi', 'search', 'resultsConfig', 'data']).toJS();

export const searchResultsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'results', 'data']).toJS();

export const searchResultsStateSelector = state =>
  state.getIn(['app', 'bi', 'search', 'results']).toJS().state;

export const searchDetailStateSelector = state =>
  state.getIn(['app', 'bi', 'search', 'editSketch']).toJS().state;

export const searchDetailFormSelector = state =>
  state.getIn(['form', 'searchRecord']);

export const sketchSettingsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'sketchSettings']).toJS();

export const sketchCommentsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'comments']).toJS();

export const sketchCommentFormSelector = state =>
  state.getIn(['app', 'bi', 'search', 'comments']).toJS();

export const sketchTagsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'tags']).toJS();

export const userSelector = state =>
  state.getIn(['app', 'global', 'user']).toJS();

export const searchResultsColumnsSelector = createSelector(
  searchResultsConfigSelector,
  () => [
    {
      headerName: 'Sketch ID',
      field: 'sketchID',
      width: 130,
      maxWidth: 130,
      minWidth: 130,
      cellRenderer: SimpleLinkRenderer,
      cellRendererParams: {
        // onClick: (_, record) => onEdit(record),
      },
    },
    { headerName: 'Description', field: 'description' },
    { headerName: 'Create Date', field: 'createDt' },
    {
      headerName: 'Actions',
      field: 'exemptionCode',
      width: 120,
      maxWidth: 120,
      minWidth: 120,
      cellRenderer: IconsRenderer,
      cellRendererParams: {
        icons: [
          {
            icon: 'fa-edit',
            onClick: (_, record) => {
              console.log(record);
            },
          },
          {
            icon: 'fa-trash',
            // onClick: (_, record) => onDelete(record),
          },
        ],
      },
    },
  ],
);

export const sortByGroupAndOrder = (a, b) =>
  a.group * 10 + a.order - (b.group * 10 + b.order);

export const searchFieldsSelector = createSelector(
  searchConfigSelector,
  searchCodesSelector,
  (config, codes) =>
    config
      .map(field => ({
        ...field,
        code: field.code || null,
        codes: codes[field.code] || [],
      }))
      .sort(sortByGroupAndOrder),
);

export const reportDefinitionsSelector = state =>
  state.getIn(['app', 'bi', 'search', 'reportDefinitions', 'data']).toJS();
